module.exports = __webpack_public_path__ + "media/images/hisp-img-66aff12bfcaf8ab03bdafa06392cff0d.jpg";